import { Box, styled } from '@mui/material'
import React from 'react'
import { BackgroundContainer, Body2, Title, _ContentTitleWithMarginTop } from './styles'
import { Grid, Typography } from '@mui/material'
import { ColorConf } from '@/config/color';

const safetyFeatures = [
  {
    image: "/images/hero-security.png",
    title: "24時間365日の監視体制",
    description:
      "テクノロジーとスタッフの常時監視体制によってすべてのユーザーに安心・安全なサービスをお届けします。"
  },
  {
    image: "/images/hero-privacy.png",
    title: "SNSには投稿されません",
    description:
      "Xアカウントに連携を行いますが、もちろん自動で投稿などは行われません。"
  },
  {
    image: "/images/hero-account.png",
    title: "実名は表示されません",
    description:
      "ニックネームでの登録が可能なため実名が表示されることはありません。"
  },
  {
    image: "/images/hero-verified.png",
    title: "本人確認が必須です",
    description:
      "安心・安全にご利用いただくため公的証明書のご提出による本人確認が必須になります。"
  },
  {
    image: "/images/hero-block.png",
    title: "悪質ユーザーは利用停止されます",
    description:
      "ユーザーからの違反報告や運営の監視により、悪質ユーザーは利用停止されます。"
  },
  {
    image: "/images/hero-badge.png",
    title: "各種認証を取得しています",
    description:
      "インターネット異性紹介事業を取得し、適切に運営がされています。"
  }
];

const ImageFlower = styled("img")({
  position: "absolute",
  top: 0,
  right: 0,
  width: 81,
  height: 81,
  "@media (min-width: 600px)": {
    width: 87,
    height: 87,
    top: -30,
  }
});

const SafetyFeatures = () => {
  return (
    <Box position="relative" mt={10}>
      <ImageFlower src="/images/hero-flower.png" alt="flower" />
      <BackgroundContainer
        sx={{
          backgroundImage: `url(${"/images/hero-bg2.png"})`,
        }}
      >
        <_ContentTitleWithMarginTop
          sx={{
            marginTop: 10,
            textShadow: ColorConf.HeroTitleTextShadow
          }}
        >
          安心・安全への取り組み
        </_ContentTitleWithMarginTop>
        <Grid container spacing={4} justifyContent="center" gap={5} mb={10}>
          {safetyFeatures.map((feature, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                "@media (min-width: 600px)": {
                  maxWidth: "40%",
                }
              }}
            >
              <Box
                sx={{
                  maxWidth: 255,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <Box
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: -65,
                      marginTop: 8,
                    }}
                  >
                    <Title
                      sx={{
                        position: "relative",
                      }}
                    >
                      <img src="/images/hero-point.png" alt="hero-point.png" style={{ position: "absolute", top: -13, left: -25, width: 50, height: 27, zIndex: 0 }} />
                      {feature.title}
                    </Title>
                  </Box>
                  <img src="/images/hero-line.avif" alt="hero-line.avif" style={{ position: "absolute", top: 20, left: 40, width: 178, height: 19 }} />
                  <img src={feature.image} alt={feature.title} style={{ width: 178, height: 142 }} />
                  <Body2
                    sx={{
                      position: "absolute",
                      bottom: -20,
                      textAlign: "center",
                      marginTop: 4,
                    }}
                  >
                    {feature.description}
                  </Body2>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </BackgroundContainer>
    </Box>
  )
}

export default SafetyFeatures